import type { TI18n } from '@muse/i18n'
import type { TMenuItemView } from '../components/types'
import { userMenuClick } from './navAnalytics'
import { getUserMenuItems } from './userMenuItems'

export const buildUserMenuItems = (t: TI18n['t'], username: string): TMenuItemView[] =>
    getUserMenuItems(username).map(item => ({
        label: t(item.labelKey),
        href: item.href,
        Icon: item.Icon,
        onClick: userMenuClick(item.analytics),
    }))
